"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconTravelDate = void 0;
var React = __importStar(require("react"));
var IconTravelDate = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M20.501,18.9854 L3.501,19.0004 C3.225,19.0004 3,18.7904 3,18.5314 L3,12.0004 L21,12.0004 L21,18.5164 C21,18.7754 20.776,18.9854 20.501,18.9854 M3.5,8.0004 L7.738,8.0004 C7.583,8.3174 7.387,8.5004 7.23,8.5004 C7.12,8.5004 7.015,8.4154 6.946,8.3424 L6.224,9.0344 C6.515,9.3394 6.863,9.5004 7.23,9.5004 C7.944,9.5004 8.527,8.9014 8.812,8.0004 L17.738,8.0004 C17.583,8.3174 17.387,8.5004 17.23,8.5004 C17.12,8.5004 17.015,8.4154 16.946,8.3424 L16.224,9.0344 C16.515,9.3394 16.863,9.5004 17.23,9.5004 C17.944,9.5004 18.527,8.9014 18.812,8.0004 L20.5,8.0004 C20.775,8.0004 21,8.2104 21,8.4684 L21,11.0004 L3,11.0004 L3,8.4684 C3,8.2104 3.225,8.0004 3.5,8.0004 M20.5,7.0004 L18.984,7.0004 C18.989,6.9164 19,6.8364 19,6.7504 C19,5.1824 18.239,4.0004 17.23,4.0004 C16.382,4.0004 15.689,4.8514 15.505,6.1204 L16.495,6.2624 C16.607,5.4824 16.965,5.0004 17.23,5.0004 C17.537,5.0004 18,5.6984 18,6.7504 C18,6.8374 17.992,6.9184 17.986,7.0004 L8.984,7.0004 C8.989,6.9164 9,6.8364 9,6.7504 C9,5.1824 8.239,4.0004 7.23,4.0004 C6.382,4.0004 5.688,4.8514 5.505,6.1204 L6.495,6.2624 C6.607,5.4824 6.965,5.0004 7.23,5.0004 C7.537,5.0004 8,5.6984 8,6.7504 C8,6.8374 7.992,6.9184 7.986,7.0004 L3.5,7.0004 C2.673,7.0004 2,7.6594 2,8.4684 L2,18.5314 C2,19.3404 2.674,20.0004 3.501,20.0004 L20.501,19.9854 C21.327,19.9854 22,19.3264 22,18.5164 L22,8.4684 C22,7.6594 21.327,7.0004 20.5,7.0004" }))); };
exports.IconTravelDate = IconTravelDate;
exports.IconTravelDate.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconTravelDate;
